import { Place } from '@mui/icons-material';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import React from 'react';
import { FavouriteAccessPointData, SearchAccessPointData } from '../../api/types';
import { SituationIndicator } from '../SituationIndicator/SituationIndicator';
import { useTranslations } from '../Translations/TranslationsProvider';

interface AccessPointTileProps {
    accessPoint: SearchAccessPointData | FavouriteAccessPointData;
    onClick: (arg: string) => void;
}

const isSearchAccessPointData = (acp: SearchAccessPointData | FavouriteAccessPointData): acp is SearchAccessPointData =>
    'accessPointLocCode' in acp;

export const AccessPointTile: React.FC<AccessPointTileProps> = ({ accessPoint, onClick }) => {
    const { translations } = useTranslations();

    if (!translations) {
        return null;
    }

    return (
        <Card key={accessPoint.accessPointCode} sx={{ cursor: 'pointer' }}>
            <CardContent onClick={() => onClick(accessPoint.accessPointCode)}>
                <Grid container alignItems="center" wrap="nowrap" justifyContent="space-between" spacing={1}>
                    <Grid item container wrap="nowrap" justifyContent="space-between" alignItems="center">
                        <Grid
                            item
                            container
                            justifyContent="space-between"
                            direction="column"
                            xs={8}
                            style={{ width: 'fit-content' }}
                        >
                            <Typography variant="h6">{accessPoint.accessPointCode}</Typography>
                            <Typography variant="body2">{accessPoint.accessPointDescription}</Typography>
                            {isSearchAccessPointData(accessPoint) && (
                                <>
                                    <Divider sx={{ my: '0.5rem' }} />
                                    <Box sx={{ display: 'flex', alignItems: 'center', ml: '-0.25rem' }}>
                                        <Place />
                                        <Typography variant="body2">
                                            {`${accessPoint.accessPointLocCode} - ${accessPoint.accessPointLocDesc}`}
                                        </Typography>
                                    </Box>
                                </>
                            )}
                        </Grid>
                        <Grid item>
                            <SituationIndicator
                                negativeStatusText={translations.ACCESS_POINT_STOP}
                                positiveStatusText={translations.ACCESS_POINT_GO}
                                situation={accessPoint.accessPointSituation}
                                textOnly
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
